import { NavLink, Outlet, Link } from 'react-router-dom';
import { getWhatsAppUrl, siteConfig } from '../config';
import { WhatsAppIcon } from './WhatsAppIcon';
import { ScrollToTop } from './ScrollToTop';
import '../App.css';

function MainNavLink({ to, children }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        isActive ? 'nav-link nav-link--active' : 'nav-link'
      }
    >
      {children}
    </NavLink>
  );
}

export function Layout() {
  return (
    <div className="app">
      <ScrollToTop />
      <div className="app__bg" aria-hidden />

      <header className="header">
        <div className="header__inner container">
          <Link className="logo" to="/">
            <span className="logo__mark">&lt;/&gt;</span>
            {siteConfig.brandName}
          </Link>
          <nav className="nav" aria-label="Primary">
            <MainNavLink to="/services">Services</MainNavLink>
            <MainNavLink to="/process">Process</MainNavLink>
            <MainNavLink to="/contact">Contact</MainNavLink>
          </nav>
          <a
            href={getWhatsAppUrl(siteConfig.defaultWhatsAppMessage)}
            className="float-wa"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open WhatsApp chat with site owner"
          >
            <WhatsAppIcon className="float-wa__icon" />
            <span className="float-wa__label">Chat</span>
          </a>
          <a
            href={getWhatsAppUrl(siteConfig.defaultWhatsAppMessage)}
            className="float-wa float-wa--mobile"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open WhatsApp chat with site owner"
          >
            <WhatsAppIcon className="float-wa__icon" />
            <span className="float-wa__label">Chat</span>
          </a>
        </div>
      </header>

      <main className="main">
        <div className="main__fill">
          <Outlet />
        </div>
      </main>

      <footer className="footer">
        <div className="container footer__inner">
          <p>
            © {new Date().getFullYear()} {siteConfig.brandName}.
          </p>
        </div>
      </footer>
    </div>
  );
}
